<div class="flex" [ngClass]="formControl.errors && formControl.dirty ? 'mb-0' : 'mb-6'">
  <om-time-input class="w-full"
    [control]="formControl"
    [disabled]="props.disabled"
    [placeholder]="props.placeholder"
    [label]="props.label"
    [format]="props.format"
  ></om-time-input>
</div>
